import React, {useState} from "react";
import PtDateTimePicker from "./pt-date-time-picker";
import {View, StyleSheet} from "react-native";
import {styleVars} from "../../../app-style-vars";
import PtText from "../pt-text/pt-text";


export default function PtDateTimeRange(props:any) {

  const startDate = props.startDate ? props.startDate : null;
  const endDate = props.endDate ? props.endDate : new Date();
  const minDate = props.minDate ? props.minDate : null;
  const maxDate = props.maxDate;

  const dateFromLabel = props.dateFromLabel ? props.dateFromLabel : 'From date';
  const dateToLabel = props.dateToLabel ? props.dateToLabel : 'To date';

  const [dateFrom, setDateFrom] = useState(startDate);
  const [dateTo, setDateTo] = useState(endDate);

  /** we set dateFrom and dateTo to keep range boundaries in sync
   * and pass actual startDate and endDate further up the chain
   */
  const dateFromChangedHandler = (data:any) => {
    if(props.startDateChangedHandler) {
      props.startDateChangedHandler(data);
    }
    setDateFrom(data.newDate);
  }

  const dateToChangedHandler = (data:any) => {
    if(props.endDateChangedHandler) {
      props.endDateChangedHandler(data);
    }
    setDateTo(data.newDate);
  }

  return (
    <View style={[styles.dateTimeRangeContainer]}>
      {props.title ?
        <View>
          <PtText style={[styles.dateTimeRangeTitleText]}>
            {props.title}
          </PtText>
        </View>
        : null
      }
      <View style={[styles.dateTimeRangeInputsContainer]}>
        <View style={[styles.fromDateContainer]}>
          <PtDateTimePicker
            title={dateFromLabel}
            initialDate={startDate}
            minDate={minDate}
            maxDate={dateTo || maxDate}
            dateChangedHandler = {dateFromChangedHandler}
          />
        </View>
        <View style={[styles.toDateContainer]}>
          <PtDateTimePicker
            title={dateToLabel}
            initialDate={endDate}
            minDate={dateFrom || minDate}
            maxDate={maxDate}
            dateChangedHandler = {dateToChangedHandler}
          />
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  dateTimeRangeContainer: {
    padding: styleVars.rem(.5),
  },
  dateTimeRangeTitleText: {
    fontSize: styleVars.rem(1),
    fontWeight: '600'
  },
  dateTimeRangeInputsContainer: {
    paddingVertical: styleVars.rem(.5),
  },
  fromDateContainer: {
    zIndex: 3
  },
  toDateContainer: {
    zIndex: 2
  }
})